// prettier-ignore
export class TokenBucket {
    capacity;
    refillPerSecond;
    tokens;
    lastRefill;
    constructor(capacity, refillPerSecond) {
        this.capacity = capacity;
        this.refillPerSecond = refillPerSecond;
        this.tokens = capacity;
    }
    take(nowMs) {
        this.lastRefill ??= nowMs;
        this.tokens = Math.min(this.capacity, this.tokens + ((nowMs - this.lastRefill) / 1000) * this.refillPerSecond);
        this.lastRefill = nowMs;
        if (this.tokens < 1)
            return false;
        this.tokens -= 1;
        return true;
    }
}
//# sourceMappingURL=limits.js.map